//import firebase from 'firebase';
import { collection, getDocs } from 'firebase/firestore/lite';
import db from '../components/Firebase/index';

// Secured Combined Catches
import { HandleExceptionWithSecureCatch } from "./CombinedCatch";

const getCovidDonorData = () => {

    const response=collection(db,'user');
    return async (dispatch) => {

//        try {

            const data = await getDocs(response);
            const donorList = data.docs.map(doc => doc.data());

            dispatch({
                type: "GET_DONOR_DATA",
                payload: donorList
            });
  /*      } catch(e) {
            dispatch(HandleExceptionWithSecureCatch(e));
            dispatch({
                type: "GET_COVID_DATA",
                payload: e.response.data
            })  
        }*/
    }
}

export default getCovidDonorData;